import styled from 'styled-components';
export const Td = styled.td.withConfig({
  displayName: "StyledComponents__Td",
  componentId: "qkrqez-0"
})(["position:relative;"]);